import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ThemeProvider } from "@/hooks/use-theme";
import Index from "./pages/Index";
import NotFound from "./pages/NotFound";
import IBKRImport from "./pages/IBKRImport";
import RevolutImport from "./pages/RevolutImport";
import DBOrder from "./pages/DBOrder";
import SMASurveillance from "./pages/SMASurveillance";
import Help from "./pages/Help";
import CollectedData from "./pages/CollectedData";
import HedgeProtection from "./pages/HedgeProtection";

const queryClient = new QueryClient();

const App = () => (
  <ThemeProvider defaultTheme="light" storageKey="gaintracker-theme">
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <Toaster />
        <Sonner />
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Index />} />
            <Route path="/ibkr-import" element={<IBKRImport />} />
            <Route path="/revolut-import" element={<RevolutImport />} />
            <Route path="/db-order" element={<DBOrder />} />
            <Route path="/sma-surveillance" element={<SMASurveillance />} />
            <Route path="/collected-data" element={<CollectedData />} />
            <Route path="/hedge-protection" element={<HedgeProtection />} />
            <Route path="/help" element={<Help />} />
            {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </BrowserRouter>
      </TooltipProvider>
    </QueryClientProvider>
  </ThemeProvider>
);

export default App;
